<!-- Logo预览功能 -->
<template>
  <div
    class="PreviewWrap">
    <div class="previewHeader">{{$t('lang.LogoPreview')}}</div>
    <div class="SingularPreview">
      <div
       class="Preview"
       :style="
        `
        width: ${VideoResolution.width}px;
        height: ${VideoResolution.height}px;
        zoom: ${VideoResolution.scaleRatio};`
      "
      >
        <div
          class="OverlayLogo"
          v-if="isShowLogo"
        >
          <VueDragResize
            :x="x"
            :y="y"
            :w="width"
            :h="height"
            :minh="minHeight"
            :minw="minWidth"
            :sticks="sticks"
            :parentLimitation="true"
            :aspectRatio="true"
            :isDraggable="isDraggable"
            :isResizable="true"
            :parentScaleX="VideoResolution.scaleRatio"
            :parentScaleY="VideoResolution.scaleRatio"
            @resizing="onResize"
            @dragging="onDrag"
            @dragstop="dragstop"
            @resizestop="resizestop"
            @deactivated="onDeactivated"
            @activated="onActivated"
            :isActive="isActive"
          >
            <img
              :src="previewObj.logoFileUrl"
              alt="image load error"
              @error.once="imgerrorfun($event)"
              ref="transitionImg"
            />
          </VueDragResize>
        </div>
      </div>
    </div>
    <div class="CloseIcon" @click="ClosePreview">
      <i class="iconfont icon-a-closethick"></i>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import VueDragResize from 'vue-drag-resize'
export default {
  props: {
    // 预览的信息
    previewObj: {
      type: Object,
      default: () => ({
        syncSwitch: false,
        logoFileUrl: '',
        logoXOffset: 0,
        logoYOffset: 0,
        logoWidth: 1920,
        logoHeight: 1080
      })
    },
    // 所选分辨率
    VideoResolution: {
      type: Object,
      default: () => ({
        width: 1920,
        height: 1080,
        scaleRatio: 0.30833333333333335
      })
    }
  },
  data () {
    return {
      width: 200,
      x: 0,
      y: 0,
      height: 100,
      zorder: 60,
      minHeight: 10,
      minWidth: 10,
      isShowLogo: false,
      defaultImg: require('./Picture-broken.png'),
      isActive: false,
      // 哪个方向可以缩放
      sticks: ['tl'], // ['tl', 'tr', 'br', 'bl']
      // 是否可拖拽
      isDraggable: false,
      // 固定位置对应的方向
      logoLocation: {
        1: 'bl',
        2: 'br',
        3: 'tr',
        4: 'tl'
      }
    }
  },
  components: {
    VueDragResize
  },
  watch: {
    previewObj: {
      immediate: true,
      handler () {
        this.logoStyle()
      }
    }
  },
  created () {
  },
  mounted () {
    Bus.$on('goTemplateBlank', (obj, flag) => {
      // 编辑模板导致页面卡死
      this.ClosePreview()
    })
  },
  methods: {
    ClosePreview () {
      this.previewObj.syncSwitch = false
    },
    imgerrorfun: function (event) {
      event.target.setAttribute('src', this.defaultImg)
    },
    onResize ({ left, top, width, height }) {
      this.x = left
      this.y = Number(top.toFixed(0))
      this.width = width
      this.height = height
      this.$emit('UpdateLocation', {
        logoXOffset: this.x,
        logoYOffset: this.y,
        logoWidth: this.width,
        logoHeight: this.height
      })
    },
    onDrag ({ left, top }) {
      this.x = left
      this.y = Number(top.toFixed(0))
      this.$emit('UpdateLocation', {
        logoXOffset: this.x,
        logoYOffset: this.y,
        logoWidth: this.width,
        logoHeight: this.height
      })
    },
    dragstop () {
    },
    resizestop () {
      // 每当组件停止调整大小时调用
    },
    onDeactivated () {
      // 每当用户单击组件外的任何位置时调用
      this.isActive = false
    },
    onActivated () {
      this.isActive = true
      // 单击组件时调用，以显示句柄
    },
    logoStyle () {
      this.isShowLogo = false
      // VueDragResize 只有初次绑定数值才生效，所以先销毁再创建
      // this.$nextTick保证Dom更新之后再去改变logo信息,
      this.$nextTick(() => {
        // 判断是固定位置还是自定义
        if (this.previewObj.custom == 0) {
          const logoLocation = this.previewObj.logoLocation
          this.sticks = [this.logoLocation[logoLocation]]
          this.isDraggable = false
        } else {
          this.sticks = ['tl', 'tr', 'br', 'bl']
          this.isDraggable = true
        }
        this.x = this.previewObj.logoXOffset
        this.y = this.previewObj.logoYOffset
        this.width = this.previewObj.logoWidth
        this.height = this.previewObj.logoHeight
        this.isShowLogo = true
      })
    }
  },
  beforeDestroy () {
  }
}
</script>

<style scoped lang="less">
.PreviewWrap {
  position: absolute;
  bottom: 20px;
  right: calc(100% + 40px);
  height: 368px;
  border: 1px solid #252525;
  border-right: none;
  padding: 5px;
  background: #444;
  z-index: 3000;
  .previewHeader {
    text-align: left;
  }
  .SingularPreview {
    .Preview {
      // width: 592px;
      // height: 333px;
      // width: 1920px;
      // height: 1080px;
      // zoom: 0.30833333333333335;
      background: #000000;
      position: relative;
      .OverlayLogo {
        width: 100%;
        height: 100%;
        .vdr {
          border: 0;
        }

        .pvwlogo:hover .vdr,
        .pgmlogo:hover .vdr {
          border: 1px dashed #fff;
        }

        img {
          width: 100%;
          height: 100%;
          //transform: scale(1.011);
          display: block;
        }
      }
    }
    .Operation {
      display: flex;
      justify-content: flex-end;
      margin-top: 100px;
      .el-button {
        width: 100px;
        height: 36px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .Cancel {
        background: #cccccc;
      }
      .Save {
        background: #00cc66;
        border: 1px solid #0f620a;
      }
    }
  }
  .CloseIcon{
    position: absolute;
    top: 0px;
    right: 10px;
  }
}

</style>
